import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { aboutimg } from "../Constant/Index";

const Services = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Services" />
			<section className="how-it-work Services">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 ">
							<div className="solve-detail-img ">
								<div className="row ">
									<div className="col-lg-6 position-relative">
										<div className="how-it-work-img">
											<figure>
												<img src={aboutimg} className="img-fluid " alt="" />
											</figure>
										</div>
									</div>
									<div className="col-lg-6 mt-5 ps-0">
										<div className="solved-heading pe-4">
											<h3 className="main-heading-font dark-color level-2 wow animate__ animate__zoomIn animated">
												Our Services
											</h3>
											<p className="primary-regular-font extra-color-5 level-7">
												Lorem ipsum dolor sit amet, consectetur adipiscing elit.
												Mauris tempor, augue sit amet condimentum euismod,
												tellus tellus pharetra massa, id aliquet eros mi at leo.
												Nunc vitae mi in arcu malesuada mollis. Quisque et
												porttitor est. Integer iaculis dui tellus, vitae pretium
												metus iaculis in. Cras faucibus vel dui eu placerat. Sed
												ultricies, massa in sodales volutpat, augue tortor
												varius turpis, tincidunt luctus tellus augue ultrices
												sem. Fusce suscipit ultrices justo quis tempus.
												Suspendisse mattis lorem quis diam vehicula, et vehicula
												felis condimentum. Nullam at lorem quis erat efficitur
											</p>
											<p className="primary-regular-font extra-color-5 level-7">
												Nunc vitae mi in arcu malesuada mollis. Quisque et
												porttitor est. Integer iaculis dui tellus, vitae pretium
												metus iaculis in. Cras faucibus vel dui eu placerat. Sed
												ultricies, massa in sodales volutpat, augue tortor
												varius turpis, tincidunt luctus tellus augue ultrices
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className=" key-features mt-5 mb-5 pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 mx-auto">
							<div className="row extra-bg-8 radius-20 p-5 position-relative">
								<div className="col-lg-12">
									<div className="row">
										<div className="col-lg-12">
											<h2 className="main-heading-font text-center dark-color extra-color-5  level-2 ">
												Key Features
											</h2>
										</div>
									</div>
									<div className="row mt-4">
										<div className="col-lg-4">
											<div className="text-center ng radius-20 p-4 dark-bg">
												<h4 className="text-white main-heading-font level-3">
													24/7 Availability
												</h4>
												<p className="text-white">
													Lorem ipsum dolor sit amet consectetur. Tortor cras
													massa nam adipiscing lacus accumsan elit morbi lacus.
												</p>
											</div>
										</div>
										<div className="col-lg-4">
											<div className="text-center ng radius-20 p-4 dark-bg">
												<h4 className="text-white main-heading-font level-3">
													Live Chat
												</h4>
												<p className="text-white">
													Lorem ipsum dolor sit amet consectetur. Tortor cras
													massa nam adipiscing lacus accumsan elit morbi lacus.
												</p>
											</div>
										</div>
										<div className="col-lg-4">
											<div className="text-center ng radius-20 p-4 dark-bg">
												<h4 className="text-white main-heading-font level-3">
													Drugs delivery & pick up
												</h4>
												<p className="text-white">
													Lorem ipsum dolor sit amet consectetur. Tortor cras
													massa nam adipiscing lacus accumsan elit morbi lacus.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default Services;
